// @module Tavanoteam.UpsellAddToCartModal.UpsellAddToCartModal
define("Tavanoteam.UpsellAddToCartModal.UpsellAddToCartModal.View", [
  "tavanoteam_upselladdtocartmodal_upselladdtocartmodal.tpl",
  "GlobalViews.Confirmation.View",
  "Utils",
  "Backbone",
], function (
  tavanoteam_upselladdtocartmodal_upselladdtocartmodal_tpl,
  GlobalViewsConfirmationView,
  Utils,
  Backbone
) {
  "use strict";

  // @class Tavanoteam.UpsellAddToCartModal.UpsellAddToCartModal.View @extends Backbone.View
  return Backbone.View.extend({
    template: tavanoteam_upselladdtocartmodal_upselladdtocartmodal_tpl,

    initialize: function (options) {
      var self = this;
      this.container = this.options.container;
      this.layout = this.container.getComponent("Layout");
      this.application = this.layout.application;
      this.getLayout = this.application.getLayout();
      this.cart = this.container.getComponent("Cart");
      this.item = options.item;
      if (this.item.get("custitem_tt_show_items_cart_modal") && this.item.get("custitem_tt_items_id_cart_modal")) {
        var searchComponent = this.container.getComponent("Search");
        var paramsUpsellCartModal = {
          id: this.item.get("custitem_tt_items_id_cart_modal"),
          fieldset: "search",
        };
        var UpsellCartModalURL = searchComponent.getUrl(paramsUpsellCartModal);
        var UpsellCartModalPromise = jQuery.ajax(UpsellCartModalURL);
        UpsellCartModalPromise.then(function (data, result, jqXhr) {
          self.UpsellCartModal = data.items;
          self.render();
        });
      }
    },

    //Create Object of Matrix Child Items
    getMatrixChildItemsInfo: function (itemObj, itemInfo) {
      var matrixChildArr = [];

      var matrixChildItems = itemInfo.matrixchilditems_detail;

      _.each(matrixChildItems, function (childItem) {
        var matrixChildObj = {};

        matrixChildObj.parentId = itemInfo.internalid;
        matrixChildObj.itemId = childItem.internalid;
        matrixChildObj.sku = childItem.itemid;
        matrixChildObj.optionName = childItem[itemObj.optionName];
        matrixChildObj.price =
          childItem.onlinecustomerprice_detail.onlinecustomerprice;
        matrixChildObj.priceFormatted =
          childItem.onlinecustomerprice_detail.onlinecustomerprice_formatted;
        matrixChildObj.maximumQuantity = childItem.maximumQuantity
          ? childItem.maximumQuantity
          : itemInfo.maximumQuantity;
        matrixChildObj.minimumQuantity = childItem.minimumquantity
          ? childItem.minimumquantity
          : itemInfo.minimumquantity;
        var parentQtyIncrement = itemInfo.custitem_qty_increment
          ? itemInfo.custitem_qty_increment
          : 1;
        matrixChildObj.quantityIncrement = childItem.custitem_qty_increment
          ? childItem.custitem_qty_increment
          : parentQtyIncrement;
        matrixChildObj.quantity = childItem.custitem_qty_increment
          ? childItem.custitem_qty_increment
          : itemInfo.custitem_qty_increment;

        //DON'T SHOW PRICE
        matrixChildObj.noPrice = itemInfo.dontshowprice;
        matrixChildObj.noPriceMessage = itemInfo.nopricemessage;

        if (matrixChildObj.noPrice) {
          if (matrixChildObj.noPriceMessage) {
            matrixChildObj.priceFormatted = matrixChildObj.noPriceMessage;
          } else {
            matrixChildObj.priceFormatted = "See Price in Cart";
          }
        }

        matrixChildArr.push(matrixChildObj);
      });

      // Sort Option Alphabetically
      matrixChildArr.sort(function (a, b) {
        var nameA = (a && a.optionName) ? a.optionName : '';
        var nameB = (b && b.optionName) ? b.optionName : '';
        return nameA.localeCompare(nameB);
      });

      //console.log('Matrix Child Items for ' + itemObj.sku, matrixChildArr);

      return matrixChildArr;
    },

    events: {
      'click [data-action="changeQuantity"]': "getQuantity",
      'mouseover [data-action="changeQuantity"]': "getQuantity",
      'change [data-action="changeQuantity"]': "validateQuantity",
      'click [data-action="plus-quantity"]': "addQuantity",
      'click [data-action="minus-quantity"]': "subQuantity",
      'click [data-action="select-option"]': "getOption",
      'change [data-action="select-option"]': "changeOption",
      'click [data-action="add-item"]': "addItem",
    },

    bindings: {},

    childViews: {},

    // **** Start Quantity Events *****

    addQuantity: function (e) {
      this.message = "";
      e.preventDefault();
      var $element = this.$(e.target),
        quantityInput = $element.parent().find("input"),
        oldValue = quantityInput.val(),
        maxQuantity = jQuery(quantityInput).attr("data-maximum"),
        incrementQuantity = jQuery(quantityInput).attr("data-increment"),
        newValue = parseFloat(oldValue) + parseInt(incrementQuantity);

      newValue = maxQuantity ? Math.min(maxQuantity, newValue) : newValue;

      quantityInput.val(newValue);
      quantityInput.change();
    },

    subQuantity: function (e) {
      this.message = "";
      e.preventDefault();
      var $element = this.$(e.target),
        quantityInput = $element.parent().find("input"),
        oldValue = quantityInput.val(),
        getMinQuantity = jQuery(quantityInput).attr("data-minimum"),
        decrementQuantity = jQuery(quantityInput).attr("data-increment"),
        minQuantity = getMinQuantity ? getMinQuantity : decrementQuantity,
        newValue = parseFloat(oldValue) - parseInt(decrementQuantity);

      newValue = Math.max(minQuantity, newValue);

      quantityInput.val(newValue);
      quantityInput.change();
    },

    getQuantity: function getQuantity(e) {
      this.message = "";
      e.preventDefault();
      var $element = this.$(e.target),
        quantityInput = $element.parent().find("input");

      this.oldQuantity = quantityInput.val();
    },

    //Validation based on Minimum Quantity and Web Store Quantity Increment
    validateQuantity: function validateQuantity(e) {
      this.message = "";
      e.preventDefault();
      var $element = this.$(e.target),
        quantityInput = $element.parent().find("input"),
        quantityValue = quantityInput.val(),
        itemId = jQuery(quantityInput).attr("data-item-id"),
        quantityIncrement = jQuery(quantityInput).attr("data-increment"),
        isInvalid = quantityValue % quantityIncrement != 0 ? true : false,
        isNull = quantityValue == 0 || quantityValue == null;

      if (isInvalid) {
        this.pdp.showMessage({
          message:
            "Invalid Quantity. Please order in multiples of " +
            quantityIncrement,
          type: "error",
          selector: "QuantityError-" + itemId,
          timeout: 2000,
        });

        var newValue = parseFloat(this.oldQuantity);

        quantityInput.val(newValue);
        quantityInput.change();

        return new jQuery.Deferred().reject();
      }

      if (isNull) {
        this.pdp.showMessage({
          message:
            "Invalid Quantity. Minimum quantity should be " + quantityIncrement,
          type: "error",
          selector: "QuantityError-" + itemId,
          timeout: 2000,
        });

        var newValue = parseFloat(quantityIncrement);

        quantityInput.val(newValue);
        quantityInput.change();

        return new jQuery.Deferred().reject();
      }
    },

    //  **** End Quantity Events ****

    // **** Start Click Events *****
    getOption: function getOption(e) {
      this.message = "";
      var el = this.$(e.currentTarget);
      this.oldOption = jQuery(el).val();
    },

    //Change Item Option Function
    changeOption: function changeOption(e) {
      var self = this;
      this.message = "";
      var oldItemId = self.oldOption;

      //Get Item and Parent Item
      var el = this.$(e.currentTarget),
        itemId = jQuery(el).val(),
        parentId = jQuery(el).find(":selected").attr("data-parent-id");

      var getParent = self.upsellItems.filter(function (i) {
        return i.itemId == parentId;
      });

      var getOptionInfo;

      _.each(getParent, function (item) {
        getOptionInfo = item.matrixChildItems.filter(function (i) {
          return i.itemId == itemId;
        });
      });

      //console.log('Item Option Information', getOptionInfo);

      var newVal = getOptionInfo[0];
      //Change Price
      this.$("span.matrix-price[data-item-id='" + oldItemId + "']").attr(
        "data-item-id",
        itemId
      );
      this.$("span.matrix-price[data-item-id='" + itemId + "']").attr(
        "data-rate",
        newVal.price
      );
      this.$("span.matrix-price[data-item-id='" + itemId + "']")
        .contents()
        .last()[0].textContent = newVal.priceFormatted;

      //Change Quantity
      this.$("input.matrix-qty[data-item-id='" + oldItemId + "']").attr(
        "data-item-id",
        itemId
      );
      this.$("input.matrix-qty[data-item-id='" + itemId + "']").attr(
        "data-sku",
        newVal.sku
      );
      this.$("input.matrix-qty[data-item-id='" + itemId + "']").attr(
        "data-maximum",
        newVal.maximumQuantity
      );
      this.$("input.matrix-qty[data-item-id='" + itemId + "']").attr(
        "data-minimum",
        newVal.minimumQuantity
      );
      this.$("input.matrix-qty[data-item-id='" + itemId + "']").attr(
        "data-increment",
        newVal.quantityIncrement
      );
      this.$("input.matrix-qty[data-item-id='" + itemId + "']").val(
        newVal.quantity
      );

      //Change Quantity Error
      this.$(
        "div.product-details-quantity-error[data-item-id='" + oldItemId + "']"
      ).attr("data-item-id", itemId);
      this.$(
        "div.product-details-quantity-error[data-item-id='" + itemId + "']"
      ).attr("data-view", "QuantityError-" + itemId);

      //Change Quantity Increment
      this.$("button.matrix-qty-btn[data-item-id='" + oldItemId + "']").attr(
        "data-item-id",
        itemId
      );
      this.$("button.matrix-qty-btn[data-item-id='" + itemId + "']").attr(
        "data-value",
        newVal.quantityIncrement
      );

      //Change Minimum Quantity
      this.$(
        "span.matrix-qty-increment[data-item-id='" + oldItemId + "']"
      ).attr("data-item-id", itemId);
      this.$("span.matrix-qty-increment[data-item-id='" + itemId + "']")
        .contents()
        .last()[0].textContent = newVal.quantityIncrement;

      //Change Select Box
      var addButton =
        this.$(
          "button.tt-ext-upselladdtocartmodal-item-row-add-to-cart-button[data-item-id='" +
          oldItemId +
          "']"
        ).length > 0
          ? this.$(
            "button.tt-ext-upselladdtocartmodal-item-row-add-to-cart-button[data-item-id='" +
            oldItemId +
            "']"
          )
          : this.$(
            "button.tt-ext-upselladdtocartmodal-item-row-add-to-cart-button[data-item-id='" +
            parentId +
            "']"
          );
      addButton.attr("data-item-id", itemId);
    },

    //Add to Cart Function
    addItem: function addItem(e) {
      var self = this;
      var qtyInput = jQuery("input[name=upselladdtocartmodal-item-quantity]");
      //Creates Item Array for addLines Function
      var itemsArr = [];

      //Cart deatils
      var itemsObj = {};
      var isMatrix = _.filter(
        jQuery("select[name=upselladdtocartmodal-item-option]").find(
          ":selected"
        ),
        function (target) {
          console.log(jQuery(target).attr("data-parent-id"));
          return (
            jQuery(target).attr("data-parent-id") ==
            jQuery(e.target).attr("data-item-id")
          );
        }
      );
      var itemId =
        isMatrix.length > 0
          ? isMatrix[0].dataset.itemId
          : jQuery(e.target).attr("data-item-id");
      //jQuery(e.target).attr("data-item-id");
      var qty = jQuery(
        _.filter(qtyInput, function (target) {
          return jQuery(target).attr("data-item-id") == itemId;
        })
      ).val();
      itemsObj.item = { internalid: itemId };
      itemsObj.quantity = parseInt(qty);
      itemsArr.push(itemsObj);
      //addLines Function and Confirmation Message
      var cartComponent = this.cart;
      var getLayout = this.getLayout;
      var viewCart = this.viewCart;
      var totalItems = itemsArr.length;
      var noun = totalItems > 1 ? "items" : "item";
      var linkingVerb = totalItems > 1 ? "are" : "is";

      cartComponent
        .addLines({
          lines: itemsArr,
        })
        .then(function () {
          self.message = "Item successfully added to your cart.";
          self.render();
        });
    },

    // **** End Click Events *****
    //Create Object of Eligible Correlated Items
    getCorrelatedItemsInfo: function () {
      var self = this;

      var eligibleItems =
        this.item.get("custitem_tt_show_items_cart_modal") &&
          this.item.get("custitem_tt_items_id_cart_modal") != "&nbsp;"
          ? _.filter(this.UpsellCartModal, function (item, index) {
            return index <= 2;
          })
          : [];

      var correlatedItemsObj = [];

      _.each(eligibleItems, function (item) {
        var itemObj = {};

        itemObj.itemId = item.internalid;
        itemObj.sku = item.itemid;
        itemObj.itemName = item.storedisplayname2;
        itemObj.itemURL = "/" + item.urlcomponent;
        itemObj.price = item.onlinecustomerprice_detail.onlinecustomerprice;
        itemObj.priceFormatted = item.onlinecustomerprice_detail.onlinecustomerprice_formatted;

        var hasImage = _.isEmpty(item.itemimages_detail) ? false : true;

        itemObj.thumbnailUrl = "";
        itemObj.thumbnailAlt = item.storedisplayname2;

        if (hasImage) {
          var getKey = _.keys(item.itemimages_detail)[0];
          itemObj.thumbnailUrl = item.itemimages_detail[getKey].urls[0].url;
          itemObj.thumbnailAlt = item.itemimages_detail[getKey].urls[0]
            .altimagetext
            ? item.itemimages_detail[getKey].urls[0].altimagetext
            : item.storedisplayname2;
        }

        itemObj.maximumQuantity = item.maximumquantity;
        itemObj.minimumQuantity = item.minimumquantity;
        itemObj.quantityIncrement = item.custitem_qty_increment
          ? item.custitem_qty_increment
          : 1;
        itemObj.quantity = item.custitem_qty_increment
          ? item.custitem_qty_increment
          : 1;

        itemObj.itemBadge = false;
        itemObj.touchpoint = self.touchpoint;
        itemObj.showRating = self.showRating;

        //DON'T SHOW PRICE
        itemObj.noPrice = item.dontshowprice;
        itemObj.noPriceMessage = item.nopricemessage;

        if (itemObj.noPrice) {
          if (itemObj.noPriceMessage) {
            itemObj.priceFormatted = itemObj.noPriceMessage;
          } else {
            itemObj.priceFormatted = "See Price in Cart";
          }
        }

        //Get Matrix Child
        itemObj.isMatrix = _.isEmpty(item.matrixchilditems_detail) ? false : true;

        if (itemObj.isMatrix) {
          var itemOptionsDetail = item.itemoptions_detail.fields;
          _.each(itemOptionsDetail, function (option) {
            if (option.sourcefrom) {
              itemObj.optionLabel = option.label;
              itemObj.optionName = option.sourcefrom;
            }
          });

          //Get Matrix Child Item Information
          var itemInfo = item;
          var matrixChildArr = self.getMatrixChildItemsInfo(itemObj, itemInfo);
          itemObj.matrixChildItems = matrixChildArr;

          //Set Default Matrix Option
          var defaultMatrixArr = [];
          var defaultMatrixObj = {};
          defaultMatrixObj = matrixChildArr[0];
          defaultMatrixArr.push(defaultMatrixObj);
          itemObj.matrixChildItemsDefault = defaultMatrixArr;
        }

        //Product Review
        var value = item.custitem_ns_pr_rating ? item.custitem_ns_pr_rating : 0;
        var fill_value = Math.round(value * 2) / 2,
          max_value = SC.CONFIGURATION.productReviews.maxRate;

        itemObj.maxValue = max_value;
        itemObj.value = value;
        itemObj.fillValue = fill_value;
        itemObj.filledBy = (fill_value * 100) / max_value;
        itemObj.buttons = _.range(max_value);
        itemObj.ratingCount = item.custitem_ns_pr_count ? item.custitem_ns_pr_count : 0;

        correlatedItemsObj.push(itemObj);
      });

      //console.log('Correlated Items Object', correlatedItemsObj);

      return correlatedItemsObj;
    },

    /**
     *
     * @param {string} value
     *
     * If the recieved value is not empty,
     * this function delete all of the #tt-ext-upselladdtocartmodal-info-card after 10seconds.
     *
     */
    hiddeInfoCard: function (value) {
      if (value) {
        setTimeout(function () {
          this.$("#tt-ext-upselladdtocartmodal-info-card").empty();
        }, 10.0 * 1000);
      }
    },

    //@method getContext @return Tavanoteam.UpsellAddToCartModal.UpsellAddToCartModal.View.Context
    getContext: function getContext() {
      //@class Tavanoteam.UpsellAddToCartModal.UpsellAddToCartModal.View.Context
      var self = this;
      this.message = this.message;
      this.hiddeInfoCard(this.message);
      this.hasEligibleItems = this.item.get("custitem_tt_show_items_cart_modal") && this.UpsellCartModal;
      if (this.hasEligibleItems) {
        var correlatedItems = this.getCorrelatedItemsInfo();
        this.upsellItems = [];
        _.each(correlatedItems, function (item) {
          self.upsellItems.push(item);
        });
      }
      return {
        message: this.message,
        hasEligibleItems: this.hasEligibleItems,
        upsellItems: this.upsellItems,
        subtotal: this.subtotal ? this.subtotal : "$0.00",
        totalItems: this.totalItems ? this.totalItems : "0",
        totalText: this.totalItems > 1 ? "Items" : "Item",
      };
    },
  });
});
